import { getTypeTag } from "@/common";

const CURRENT_HOST = `${new URL(window.location).origin}`;

const YAHOO_SEARCH_API_URL = `/api/get.php`;

const YAHOO_COBRAND_URL = (query, action, typeTag = null, guid = null) => {
    const url = new URL("https://services.freshy.com/crx/search.php");
    if (guid) url.searchParams.set("guid", guid);
    if (typeTag) url.searchParams.set("type", getTypeTag(typeTag));
    else if (!typeTag && !guid)
        url.searchParams.set("type", getTypeTag(`Y219_F163_205213`));

    if (query && action) {
        url.searchParams.set("k", query);
        url.searchParams.set("action", action);
        return url.toString();
    }
    return null;
};

const COBRAND_URL = (query, typeTag = null) => {
    const url = new URL(
        "https://search.yahoo.com/yhs/search?hspart=trp&hsimp=yhs-001&grd=1"
    );
    if (typeTag) url.searchParams.set("type", getTypeTag(typeTag));
    else if (!typeTag)
        url.searchParams.set("type", getTypeTag(`Y219_F163_210843_052322`));

    if (query) {
        url.searchParams.set("p", query);
        return url.toString();
    }
    return url;
};

export { YAHOO_SEARCH_API_URL, CURRENT_HOST, YAHOO_COBRAND_URL, COBRAND_URL };
